@import url("../dropdown/style.module.css");

.search {
  margin: 0 16px 20px;
}

.search > div > input {
  padding-left: 8px;
}
